import { render, staticRenderFns } from "./AuthGuide.vue?vue&type=template&id=05058aed&scoped=true"
import script from "./AuthGuide.vue?vue&type=script&lang=js"
export * from "./AuthGuide.vue?vue&type=script&lang=js"
import style0 from "./AuthGuide.vue?vue&type=style&index=0&id=05058aed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05058aed",
  null
  
)

export default component.exports